<form [formGroup]="orgForm" (ngSubmit)="updateOrgDetails()" class="grid grid-cols-12 gap-6 p-4 w-full"
    *ngIf="!isInitialLoading">

    <div class="col-span-9 flex flex-col gap-4">
        <div class="grid grid-cols-2 gap-4">
            <ng-container *ngFor="let field of basicFields">
            <div class="mb-3">
                <label class="block text-sm font-medium">
                {{ field.label }}
                <span *ngIf="field.required" class="text-red-500">*</span>
                </label>

                <input
                pInputText
                class="w-full"
                [type]="field.type"
                [formControlName]="field.key"
                />

                <!-- Validation -->
                <div
                class="text-red-500 text-xs mt-1"
                *ngIf="
                    orgForm.get(field.key)?.invalid &&
                    orgForm.get(field.key)?.touched
                "
                >
                <span *ngIf="orgForm.get(field.key)?.errors?.['required']">
                    {{ field.label }} is required
                </span>

                <span *ngIf="orgForm.get(field.key)?.errors?.['email']">
                    Enter a valid email address
                </span>
                </div>
            </div>
       </ng-container>

       <ng-container *ngFor="let field of billingFields">
  <div class="mb-3" >
    <label class="block text-sm font-medium">
      {{ field.label }}
      <span *ngIf="field.required" class="text-red-500">*</span>
    </label>

    <ng-container [ngSwitch]="field.type">

      <input
        *ngSwitchCase="'text'"
        pInputText
        class="w-full"
        [formControlName]="field.key"
        [readonly]="field.readonly"
        [attr.maxLength]="field.maxLength"
        [placeholder]="field.label"
      />

      <p-dropdown
        *ngSwitchCase="'select'"
        [options]="field.data"
        class="w-full"
        optionLabel="name"
        (onChange)="onBillingStateChange($event)"
        optionValue="code"
        formControlName="billing_state"
        placeholder="Select State"
        ></p-dropdown>

      <input
        *ngSwitchCase="'email'"
        pInputText
        type="email"
        class="w-full"
        [formControlName]="field.key"
      />

      <p-checkbox
        *ngSwitchCase="'checkbox'"
        binary="true"
        [formControlName]="field.key"
      ></p-checkbox>

    </ng-container>

    <small class="text-gray-500" *ngIf="field.hint">
      {{ field.hint }}
    </small>

    <div
      class="text-red-500 text-xs mt-1"
      *ngIf="orgForm.get(field.key)?.invalid && orgForm.get(field.key)?.touched"
    >
      Invalid {{ field.label }}
    </div>
  </div>
</ng-container>


            <div>
                <label>Status</label>
                <p-select [options]="statusOptions" formControlName="status" placeholder="Select status"
                    class="w-full" />
                <div class="text-red-500 text-xs mt-1"
                    *ngIf="orgForm.get('status')?.hasError('required') && orgForm.get('status')?.touched">
                    Status is required.
                </div>
            </div>

            <div>
                <label>Date Format</label>
                <input pInputText formControlName="dateFormat" class="w-full" />
            </div>
        </div>

        <!-- Lead Channels -->
        <div>
            <label class="block mb-1">Lead Channels</label>
            <table class="min-w-full text-sm border border-gray-200 rounded">
                <thead class="bg-gray-100 text-left">
                    <tr>
                        <th class="p-2 border-b">#</th>
                        <th class="p-2 border-b">Channel</th>
                        <th class="p-2 border-b">Enabled</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let option of leadChannelOptions; let i = index" class="border-b">
                        <td class="p-2">{{ i + 1 }}</td>
                        <td class="p-2">{{ option.label }}</td>
                        <td class="p-2">
                            <input type="checkbox" [checked]="isChannelChecked(option.value)"
                                (change)="toggleLeadChannel(option.value, $event)" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>


        <!-- MailHub Users -->
        <div>
            <label class="block mb-1 font-semibold text-sm">MailHub Users</label>

            <!-- Existing users -->
            <div class="flex flex-wrap gap-2 mb-2">
                <div *ngFor="let user of orgForm.get('mailhub_users')?.value; let i = index"
                    class="bg-gray-200 text-sm px-3 py-1 rounded flex items-center gap-2">
                    {{ user }}
                    <button type="button" (click)="removeMailhubUser(i)" class="text-red-600 hover:text-red-800">
                        <i class="pi pi-trash"></i>
                    </button>
                </div>
            </div>

            <!-- Input and Add Button -->
            <div class="flex items-center gap-2">
                <input type="email" [(ngModel)]="newMailhubUser" placeholder="Enter email"
                    class="w-full px-3 py-2 border rounded shadow-sm text-sm" [ngModelOptions]="{ standalone: true }" />
                <button type="button" (click)="addMailhubUser()"
                    class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 text-sm rounded min-w-[100px]">
                    + Add
                </button>
            </div>

            <!-- Error message -->
            <div *ngIf="mailhubError" class="text-red-500 text-xs mt-1">
                {{ mailhubError }}
            </div>
        </div>


        <!-- Feature Modules -->
        <div class="mt-4">
            <label class="block mb-1 font-semibold text-sm">Feature Modules</label>
            <table class="min-w-full text-sm border border-gray-200 rounded">
                <thead class="bg-gray-100 text-left">
                    <tr>
                        <th class="p-2 border-b">#</th>
                        <th class="p-2 border-b">Module</th>
                        <th class="p-2 border-b">Enabled</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let module of featureModuleOptions; let i = index" class="border-b">
                        <td class="p-2">{{ i + 1 }}</td>
                        <td class="p-2">{{ module.label }}</td>
                        <td class="p-2">
                            <input type="checkbox" [checked]="isFeatureChecked(module.value)"
                                (change)="toggleFeatureModule(module.value, $event)" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>


        <!-- WooCommerce Credentials -->
        <div class="border p-4 rounded bg-gray-50">
            <h4 class="font-semibold mb-4">WooCommerce</h4>

            <!-- Apply formGroup to a container div -->
            <div [formGroup]="orgForm.get('woocomerce_cred')" class="grid grid-cols-2 gap-4">

                <div>
                    <label for="pdf_url" class="block mb-1 text-sm font-medium text-gray-700">PDF URL</label>
                    <input id="pdf_url" pInputText formControlName="pdf_url" placeholder="PDF URL" class="w-full" />
                </div>

                <div>
                    <label for="base_url" class="block mb-1 text-sm font-medium text-gray-700">Base URL</label>
                    <input id="base_url" pInputText formControlName="base_url" placeholder="Base URL" class="w-full" />
                </div>

                <div>
                    <label for="consumer_key" class="block mb-1 text-sm font-medium text-gray-700">Consumer Key</label>
                    <input id="consumer_key" pInputText formControlName="consumer_key" placeholder="Consumer Key"
                        class="w-full" />
                </div>

                <div>
                    <label for="consumer_secret" class="block mb-1 text-sm font-medium text-gray-700">Consumer
                        Secret</label>
                    <input id="consumer_secret" pInputText formControlName="consumer_secret"
                        placeholder="Consumer Secret" class="w-full" />
                </div>

                <div>
                    <label for="PDF_INVOICE_ACCESS_KEY" class="block mb-1 text-sm font-medium text-gray-700">Invoice
                        Key</label>
                    <input id="PDF_INVOICE_ACCESS_KEY" pInputText formControlName="PDF_INVOICE_ACCESS_KEY"
                        placeholder="Invoice Key" class="w-full" />
                </div>

            </div>
        </div>


        <div class="border p-4 rounded bg-gray-50 mt-4">
            <h4 class="font-semibold mb-2">Other Settings</h4>

            <!-- Apply formGroup to container div -->
            <div [formGroup]="orgForm.get('other_settings')" class="grid grid-cols-2 gap-2">
                <input pInputText formControlName="currency" placeholder="Currency (e.g., INR, USD)" />
            </div>
        </div>


        <div class="border p-4 rounded bg-gray-50 mt-4">
            <h4 class="font-semibold mb-2">Boolean Settings</h4>

            <div class="grid grid-cols-2 gap-4">

                <div class="flex items-center gap-2">
                    <p-checkbox formControlName="isCron" binary="true" inputId="isCron">
                    </p-checkbox>
                    <label for="isCron" class="text-sm text-gray-700 cursor-pointer">Is Cron</label>
                </div>

                <div class="flex items-center gap-2">
                    <p-checkbox formControlName="is_center" binary="true" inputId="is_center">
                    </p-checkbox>
                    <label for="is_center" class="text-sm text-gray-700 cursor-pointer">Is Center</label>
                </div>

                <div class="flex items-center gap-2">
                    <p-checkbox formControlName="get_location" binary="true" inputId="get_location">
                    </p-checkbox>
                    <label for="get_location" class="text-sm text-gray-700 cursor-pointer">Get Location</label>
                </div>

                <div class="flex items-center gap-2">
                    <p-checkbox formControlName="is_fixed_col" binary="true" inputId="is_fixed_col">
                    </p-checkbox>
                    <label for="is_fixed_col" class="text-sm text-gray-700 cursor-pointer">Is Fixed Column</label>
                </div>

                <div class="flex items-center gap-2">
                    <p-checkbox formControlName="is_user_wise_lead_space" binary="true"
                        inputId="is_user_wise_lead_space">
                    </p-checkbox>
                    <label for="is_user_wise_lead_space" class="text-sm text-gray-700 cursor-pointer">Is User-wise Lead
                        Space</label>
                </div>

            </div>
        </div>





        <!-- Submit Button -->
        <button pButton type="submit" label="Update" icon="pi pi-check" [loading]="isUpdating" [disabled]="isUpdating"
            class="w-full mt-4"></button>
    </div>

    <!-- Image Upload -->
    <div class="col-span-3 flex flex-col items-center">
        <div *ngIf="imageUrl; else noImage">
            <img [src]="imageUrl" class="w-32 h-32 rounded-full mb-4 border" />
        </div>
        <ng-template #noImage>
            <div class="w-32 h-32 flex items-center justify-center border rounded-full mb-4 text-gray-400">
                No Image
            </div>
        </ng-template>

        <input type="file" hidden #fileInput (change)="handleFileChange($event)" />
        <button type="button" class="bg-yellow-400 px-4 py-2 rounded shadow" (click)="fileInput.click()">Upload</button>
    </div>
</form>

<div *ngIf="isInitialLoading" class="flex justify-center items-center h-[80vh]">
    <p-progressSpinner></p-progressSpinner>
</div>